import { useContext } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import CMSLink from '@tmh-website/components/shared/CMSLink';
import { Color } from '@tmh-website/shared/colors';
import { GlobalContext } from '@tmh-website/shared';
import { isValidLinkField } from '@tmh-website/shared/cms';
import { LocalePrefix } from '@tmh-website/shared/const';
import { useLogoComponent } from '@tmh-website/shared/hooks';

import * as Styled from './FooterLegalLinks.styles';

interface FooterLegalLinksProps {
  locale: LocalePrefix;
  isStandaloneMode: boolean;
}

const FooterLegalLinks = ({ locale, isStandaloneMode }: FooterLegalLinksProps) => {
  const { footerLegalLinks } = useContext(GlobalContext);

  const { t } = useTranslation();
  const { textOpacity } = useTheme();

  const LogoComponent = useLogoComponent();

  if (!footerLegalLinks) {
    return null;
  }

  return (
    <Styled.Container>
      {/* Copyright */}
      <Styled.CopyrightText as='small' $style='uiTextSmall' $color={Color.Neutral_0_White} $opacity={textOpacity}>
        Copyright &copy; {new Date().getFullYear()} The Mobility House GmbH
      </Styled.CopyrightText>
      {/* END | Copyright */}

      {/* Logotype */}
      <Styled.LogoLink href='/' locale={locale} aria-label={t('global:menu.backToHome') as string}>
        <LogoComponent />
      </Styled.LogoLink>
      {/* END | Logotype */}

      {/* Legal links */}
      {footerLegalLinks?.length > 0 && (
        <Styled.EntriesNav aria-label={t('global:navigation.footer.legal') as string}>
          <Styled.EntriesUl>
            {footerLegalLinks.map(
              legalLink =>
                isValidLinkField(legalLink.link) && (
                  <Styled.EntryLi key={legalLink.link.label}>
                    <CMSLink link={legalLink.link} isStandaloneMode={isStandaloneMode} locale={locale}>
                      <Styled.AnchorLink>{legalLink.link.label}</Styled.AnchorLink>
                    </CMSLink>
                  </Styled.EntryLi>
                )
            )}
          </Styled.EntriesUl>
        </Styled.EntriesNav>
      )}
      {/* END | Legal links */}
    </Styled.Container>
  );
};

export default FooterLegalLinks;
